import { Icon } from '@iconify/react';
import wrappedGift from '@iconify/icons-emojione-monotone/wrapped-gift';
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography, Box } from '@mui/material';
import { useState, useEffect } from 'react';
import { db } from '../../../database/db';
import { doc, onSnapshot } from 'firebase/firestore';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(4, 0),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.warning.dark, 0)} 0%, ${alpha(
    theme.palette.warning.dark,
    0.24
  )} 100%)`
}));

export default function TotalGifts() {
  const [tokenImg, setTokenImg] = useState("");

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "AppConfig", "token"), (doc) => {
      if (doc.exists()) {
        setTokenImg(doc.data().imageUrl);
      }
    });
    return () => unsub();
  }, []);

  return (
    <RootStyle>
      <IconWrapperStyle>
        {tokenImg ? (
          <Box component="img" src={tokenImg} sx={{ width: 32, height: 32 }} />
        ) : (
          <Icon icon={wrappedGift} width={24} height={24} />
        )}
      </IconWrapperStyle>
      <Typography variant="h3">172</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        FIRE TOKENS
      </Typography>
    </RootStyle>
  );
}
